import { render, staticRenderFns } from "./StoreProductTypeTable.vue?vue&type=template&id=c758a7fa&scoped=true"
import script from "./StoreProductTypeTable.vue?vue&type=script&lang=js"
export * from "./StoreProductTypeTable.vue?vue&type=script&lang=js"
import style0 from "./StoreProductTypeTable.vue?vue&type=style&index=0&id=c758a7fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c758a7fa",
  null
  
)

export default component.exports